import { defaultStyleConfig } from './_base.overrides';

export default {
  input: defaultStyleConfig.inputBaseStyles,
};
